export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Unable to connect. Please check your internet connection.',
  RATE_LIMITED: 'Too many searches - please wait a moment and try again.',
  AGENT_UNAVAILABLE: 'Our AI search is temporarily unavailable - try the regular help center search.',
  TIMEOUT: 'The search is taking longer than expected - try again.',
  GENERIC_ERROR: 'Something went wrong. Please try again.',
};
